import { Box } from '@mui/material';
import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledBabaBundle = styled.div`
  width: 343px;
  height: 277.3px;
  background: ${(props: any) => `url("${props.backgroundSrc}")`};
  background-size: cover;
  font-family: var(--font-family), Ariel;
  position: relative;
  font-style: italic;

  .badge-sale-number {
    font-style: italic;
  }

  .container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 6px 15.3px;
  }

  .products {
    display: flex;
    flex-direction: column;
    background-size: 100% 100%;
    position: relative;
    align-items: center;
    height: 214px;
  }
` as any;

export const StyledSubProductsContainer = styled(Box)`
  box-sizing: border-box;
  width: 331px;
  height: 92px;
  display: flex;
  padding: 4px;
  margin: 4px auto;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  white-space: nowrap;
`;
